import { EnumBuilder } from '@mntn-dev/utility-types'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { NoneableSchema } from '../../noneable-schema.ts'

export const [BillingMethods, BillingMethodSchema, BillingMethodMap] =
  EnumBuilder('mntn_credits', 'meta', 'tiktok', 'linkedin', 'invoice', 'stripe')

export type BillingMethod = ZodSimplify<typeof BillingMethodSchema>

export const NoneableBillingMethodSchema = NoneableSchema(BillingMethodSchema)
export type NoneableBillingMethod = ZodSimplify<
  typeof NoneableBillingMethodSchema
>

export function isBillingMethod(value: unknown): value is BillingMethod {
  return BillingMethodSchema.safeParse(value).success
}
export const BillingMethodPriority: Record<BillingMethod, number> = {
  mntn_credits: 0,
  meta: 1,
  tiktok: 2,
  linkedin: 3,
  stripe: 4,
  invoice: 5,
}
